import { render } from "./ButtonRequest.vue?vue&type=template&id=4e4dc148&scoped=true"
import script from "./ButtonRequest.vue?vue&type=script&lang=js"
export * from "./ButtonRequest.vue?vue&type=script&lang=js"

import "./ButtonRequest.vue?vue&type=style&index=0&id=4e4dc148&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4dc148"]])

export default __exports__